import React, { useRef, useState } from "react";
import { func, string } from "prop-types";
import { Badge, Button, Image, Stack } from "react-bootstrap";
import { uploadVideo } from "@helpers";
import { useEffect } from "react";
import clsx from "clsx";
import { VIDEO_FALLBACK_169 } from "@constants";

const VideoUploader = ({ error, onUploadFinish, src }) => {
  // state
  const [videoSource, setVideoSource] = useState({
    name: "",
    src: "",
    type: "",
  });

  // variables

  // logics before hooks
  useEffect(() => {
    setVideoSource({ ...videoSource, src });
  }, [src]);
  // hooks
  const videoRef = useRef(null);

  // logics
  const upload = () => {
    uploadVideo((files) => {
      if (files.length === 1) {
        const { fileUrl, originalFile } = files[0];
        const { name, type } = originalFile.file;
        setVideoSource({ src: fileUrl, name, type });
      }
    });
  };

  const handleVideoLoaded = () => {
    onUploadFinish({
      ...videoSource,
      duration: parseInt(videoRef.current?.duration),
    });
  };

  // UI partials

  // effects
  useEffect(() => {
    videoRef.current?.load();
  }, [videoSource.src]);

  useEffect(() => {
    setVideoSource({ ...videoSource, src: src });
  }, []);

  // render
  return (
    <div
      className={clsx(
        "d-grid w-100 h-100 border rounded",
        error ? "border-danger" : ""
      )}
    >
      <Stack gap={3} className="align-items-center p-3 m-auto w-100">
        {videoSource.src ? (
          <video
            controls
            autoPlay={false}
            ref={videoRef}
            className="w-100"
            onLoadedData={handleVideoLoaded}
          >
            <source src={videoSource.src} type={videoSource.type} />
          </video>
        ) : (
          <Image thumbnail src={VIDEO_FALLBACK_169} alt="image" />
        )}
        {/* <span className="text-muted">
          {videoSource.name || "No file selected"}
        </span> */}
        <div className="d-flex flex-column align-items-center">
          <Button variant="outline-primary" onClick={upload}>
            {videoSource.src ? "CHANGE" : "UPLOAD"} VIDEO
          </Button>
          <div type="invalid" className="text-danger text-center mt-2">
            {error}
          </div>
        </div>
        <Stack className="align-items-center" gap={1}>
          <span>Accepted video's extension:</span>
          <div>
            <Stack direction="horizontal" gap={1} className="flex-wrap">
              <Badge bg="secondary">.mp4</Badge>
              <Badge bg="secondary">.mov</Badge>
              <Badge bg="secondary">.avi</Badge>
              <Badge bg="secondary">.wmv</Badge>
            </Stack>
          </div>
        </Stack>
      </Stack>
    </div>
  );
};

/* required: display name */
VideoUploader.displayName = "VideoUploader";

/* required: props types */
VideoUploader.propTypes = { error: string, onUploadFinish: func };

/* required: default props */
VideoUploader.defaultProps = { error: "", onUploadFinish: () => {} };

export { VideoUploader };
